var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24998 12.6469L16.6781 20.0625C16.7755 20.1488 16.8937 20.2082 17.021 20.2349C17.1483 20.2617 17.2803 20.2549 17.4042 20.2152C17.5281 20.1754 17.6395 20.1042 17.7275 20.0084C17.8155 19.9126 17.8771 19.7956 17.9062 19.6688L21.4312 4.27503C21.4608 4.14246 21.4538 4.00435 21.411 3.87544C21.3682 3.74654 21.2912 3.63168 21.1882 3.54312C21.0852 3.45457 20.9601 3.39565 20.8262 3.37265C20.6923 3.34965 20.5547 3.36343 20.4281 3.41253L3.12185 10.2094C2.4281 10.4813 2.52185 11.4938 3.2531 11.6438L8.24998 12.6469Z",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.6468L21.0094 3.43115",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4594 16.3501L9.53437 19.2751C9.43002 19.3811 9.29653 19.4536 9.15085 19.4835C9.00517 19.5134 8.85388 19.4994 8.71622 19.4431C8.57856 19.3868 8.46073 19.2909 8.37772 19.1675C8.2947 19.0441 8.25025 18.8988 8.25 18.7501V12.647",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8a7ec31e230ab8e3cc4095650ae16194.svg";
export { ForwardRef as ReactComponent };